(function($) {
    $.widget("ca.caSelect", {
        options: {
            width : '',
            minWidth: '',
            divClass: '',
            selectType: '',
            allow_single_deselect: false
        },

        _create : function() {
            var options = this.options;
            var select = this.element;
            var width = options.width;
            var selectOptions;

            if (select.attr('id')) {
                if ($('#' + select.attr('id') + '_chosen').length > 0) {
                    this.reset();
                    return;
                }
            }
            if (options.selectType == 'select') {
                selectOptions = $.extend({}, options);
                if (selectOptions.width == '') {
                    selectOptions.width = '100%';
                }
                selectOptions.disable_search_threshold = '50';
                $(select).chosen(selectOptions);
            }
            if (options.selectType == 'selectChosen') {
                selectOptions = $.extend({}, options);
                if (selectOptions.width == '') {
                    selectOptions.width = '100%';
                }
                $(select).chosen(selectOptions);
            }

            var formGroup = select.parents('.form-group');

            if (!width) {
                if (formGroup.length) {
                    width = '100%';
                } else {
                    width = select.outerWidth();
                }
                if (!width) {
                    width = select.css('width');
                }
            }
            var wrapper = select.parent();
            wrapper.addClass(options.divClass);
            if (options.minWidth) {
                $('.chosen-drop').css({minWidth: options.minWidth});
                wrapper.children('.chosen-container').css({minWidth: options.minWidth});
            }
            if (typeof options.containerClass !== 'undefined') {
                wrapper.children('.chosen-container').addClass(options.containerClass);
            }
            width = String(width);
            if (width.indexOf('px') == -1 && width.indexOf('%') == -1) {
                width += 'px';
            }

            wrapper.children('.chosen-container').width(width);
            wrapper.children('.chosen-container').children('.chosen-drop').css('min-width', width);

            if (options.allOption) {
                var allOptionText = options.allOption;
                $(select).prepend('<option value="" class="chosen-all-option" disabled="disabled" style="">' + allOptionText + '</option>');
                $(select).trigger('chosen:updated');
            }

            if (options.dataSource) {
                $(select).append('<option value=""></option>');
                $(select).trigger('chosen:updated');
                var getData = function(input) {
                    var data = {};
                    if (options.dataSource.data) {
                        for (var i in options.dataSource.data) {
                            data[i] = $(options.dataSource.data[i]).val();
                        }
                    }
                    if (input) {
                        data.input = input;
                    }
                    return data;
                };
                
                var ajax = function( request, response ) {
                    var value = $('#hidden-' + $(select).attr('name')).val();
                    $.ajax({
                        method: 'POST',
                        url:options.dataSource.url,
                        data: getData(request ? request.term : null),
                        dataType: "json",
                        beforeSend: function() {
                            $(select).empty();
                        },
                        success: function(data) {
                            $(select).append('<option value=""></option>');
                            if (!data.length) {
                                return;
                            }
                            $.map( data, function( item ) {
                                $(select).append('<option value="'+ item.id + '">' + item.label + '</option>');
                            });
                            $(select).trigger('chosen:updated');
                            if (request) {
                                wrapper.find('.chosen-search input').val(request.term);
                              }
                            if (options.dataSource.afterSuccess && options.dataSource.afterSuccess) {
                                options.dataSource.afterSuccess.apply(this, [data]);
                            }
                            if (value) {
                                $(select).find('option').each(function(){
                                    if (this.value == value) {
                                        $(select).val(value).trigger('chosen:updated');
                                    }
                                });
                            }
                        }
                    });
                };
                
                if (options.dataSource.reload) {
                    for (var i in options.dataSource.reload) {
                        $(options.dataSource.reload[i]).on(i, ajax);
                    }
                }
                
                if (options.dataSource.preload) {
                    ajax();
                }
                
                wrapper.find('.chosen-search input').autocomplete({
                    source: function (request, response) {
                        ajax(request, response);
                    }
                });
            }
            
            wrapper.on('click', '.chosen-all-option', function(e) {
                e.preventDefault();
                $(select).find('option:not(:disabled)').prop('selected', true);
                $(select).trigger('chosen:updated');
            });
        },

        reset: function() {
            var isMultiple = this.element.prop('multiple');
            var defaultValue = isMultiple ? [] : '';
            this.element.find('option').each(function(i, option) {
                if ($(option).prop('defaultSelected')) {
                    var defaultOptionValue = $(option).val();
                    $(option).val(defaultOptionValue);

                    if (isMultiple) {
                        defaultValue.push(defaultOptionValue);
                    } else {
                        defaultValue = defaultOptionValue;
                    }
                }
            });
            this.element.val(defaultValue);
            this.element.trigger('chosen:updated');
        }
    });
})(jQuery);
